import { Guid } from 'Lib/Guid';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getWorksheetProviderProps } from '.';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';
import { WorksheetInjectedConsumerProps, WorksheetInjectedPropsModifier } from './types';

let WorksheetSnapshotPreviewInjectedPropsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const worksheetId = useSelector((state) => state.worksheetEditor.worksheetId) as Guid;

  const getProviderProps = useCallback(
    (consumerProps: WorksheetInjectedConsumerProps, modifiers: Array<WorksheetInjectedPropsModifier>) =>
      getWorksheetProviderProps(
        consumerProps,
        {
          worksheetId,
          locked: true,
          setValue: (_: any) => {},
          synchronise: () => {},
          worksheetSelector: (state) => state.worksheetEditor.snapshotPreview?.snapshot,
          worksheetConfigSelector: (state) => state.worksheetEditor?.config,
          worksheetTypeSelector: (state) => state.worksheetEditor?.worksheetType,
        },
        modifiers
      ),
    [worksheetId]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { WorksheetSnapshotPreviewInjectedPropsProvider };
export default WorksheetSnapshotPreviewInjectedPropsProvider;
